'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('./index.css');
var classnames = require('classnames');
var React7 = require('react');
var reactDeviceDetect = require('react-device-detect');
var _throttle = require('lodash/throttle');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefault(classnames);
var React7__default = /*#__PURE__*/_interopDefault(React7);
var _throttle__default = /*#__PURE__*/_interopDefault(_throttle);

var GhostContext = React7__default.default.createContext({
  isActive: false,
  ghost: false
});
var GhostAreaInstanceContext = React7__default.default.createContext({
  getGhostArea: () => null
});
var useThrottle = (func, throttle = 0) => {
  return React7__default.default.useMemo(() => {
    if (func && throttle) {
      return _throttle__default.default(func, throttle);
    }
    return func;
  }, [func, throttle]);
};

// src/typings/enums.ts
var Direction = /* @__PURE__ */ ((Direction2) => {
  Direction2["Center"] = "Center";
  Direction2["Right"] = "Right";
  Direction2["RightTop"] = "RightTop";
  Direction2["Top"] = "Top";
  Direction2["TopLeft"] = "TopLeft";
  Direction2["Left"] = "Left";
  Direction2["LeftBottom"] = "LeftBottom";
  Direction2["Bottom"] = "Bottom";
  Direction2["BottomRight"] = "BottomRight";
  return Direction2;
})(Direction || {});
var DirectionCount = /* @__PURE__ */ ((DirectionCount2) => {
  DirectionCount2[DirectionCount2["Five"] = 0] = "Five";
  DirectionCount2[DirectionCount2["Nine"] = 1] = "Nine";
  return DirectionCount2;
})(DirectionCount || {});

// src/utils/angleToDirection.ts
var nineDirectionAngleMap = {
  ["Center" /* Center */]: [
    {
      min: 0,
      max: 0
    }
  ],
  ["Right" /* Right */]: [
    {
      min: 0,
      max: 22.5
    },
    {
      min: 337.5,
      max: 360
    }
  ],
  ["RightTop" /* RightTop */]: [
    {
      min: 22.5,
      max: 67.5
    }
  ],
  ["Top" /* Top */]: [
    {
      min: 67.5,
      max: 112.5
    }
  ],
  ["TopLeft" /* TopLeft */]: [
    {
      min: 112.5,
      max: 157.5
    }
  ],
  ["Left" /* Left */]: [
    {
      min: 157.5,
      max: 202.5
    }
  ],
  ["LeftBottom" /* LeftBottom */]: [
    {
      min: 202.5,
      max: 247.5
    }
  ],
  ["Bottom" /* Bottom */]: [
    {
      min: 247.5,
      max: 292.5
    }
  ],
  ["BottomRight" /* BottomRight */]: [
    {
      min: 292.5,
      max: 337.5
    }
  ]
};
var fiveDirectionAngleMap = {
  ["Center" /* Center */]: [
    {
      min: 0,
      max: 0
    }
  ],
  ["Top" /* Top */]: [
    {
      min: 45,
      max: 135
    }
  ],
  ["Left" /* Left */]: [
    {
      min: 135,
      max: 225
    }
  ],
  ["Bottom" /* Bottom */]: [
    {
      min: 225,
      max: 315
    }
  ],
  ["Right" /* Right */]: [
    {
      min: 315,
      max: 360
    },
    {
      min: 0,
      max: 45
    }
  ]
};
var angleToDirection = (mode, angle) => {
  let direction = "Center" /* Center */;
  if (angle === void 0)
    return direction;
  const directionAngleMap = mode === 0 /* Five */ ? fiveDirectionAngleMap : nineDirectionAngleMap;
  for (const key of Object.keys(directionAngleMap)) {
    const ranges = directionAngleMap[key];
    const isInclude = ranges.some(({ min, max }) => {
      return angle >= min && angle < max;
    });
    if (isInclude) {
      direction = key;
      break;
    }
  }
  return direction;
};

// src/utils/index.ts
var getAngle = (diffX, diffY) => {
  const distanceToCenter = Math.sqrt(diffX * diffX + diffY * diffY);
  if (distanceToCenter === 0)
    return void 0;
  const angle = Math.acos(diffX / distanceToCenter);
  return diffY > 0 ? 360 - angle * 180 / Math.PI : angle * 180 / Math.PI;
};
var getStyleByRadius = (radius) => {
  const diameter = radius * 2;
  return {
    width: diameter,
    height: diameter
  };
};
var size = 20;
var getArrowColor = (isActive) => {
  return isActive ? "#a6a6a6" : "#ddd";
};
var Down = ({ isActive }) => {
  return /* @__PURE__ */ React7__default.default.createElement(
    "svg",
    {
      viewBox: "0 0 1024 1024",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      "p-id": "893",
      width: size,
      height: size
    },
    /* @__PURE__ */ React7__default.default.createElement(
      "path",
      {
        d: "M1003.52 240.64c-30.72-30.72-76.8-30.72-107.52 0L512 619.52 133.12 240.64C102.4 209.92 51.2 209.92 20.48 240.64s-30.72 76.8 0 107.52l435.2 435.2c30.72 30.72 76.8 30.72 107.52 0l435.2-435.2c30.72-30.72 30.72-76.8 5.12-107.52z",
        fill: getArrowColor(isActive),
        "p-id": "894"
      }
    )
  );
};
var Up = ({ isActive }) => {
  return /* @__PURE__ */ React7__default.default.createElement(
    "svg",
    {
      viewBox: "0 0 1024 1024",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      "p-id": "1031",
      width: size,
      height: size
    },
    /* @__PURE__ */ React7__default.default.createElement(
      "path",
      {
        d: "M20.48 783.36c30.72 30.72 76.8 30.72 107.52 0L512 404.48l378.88 378.88c30.72 30.72 76.8 30.72 107.52 0 30.72-30.72 30.72-76.8 0-107.52L563.2 240.64c-30.72-30.72-76.8-30.72-107.52 0L20.48 675.84c-25.6 30.72-25.6 76.8 0 107.52z",
        fill: getArrowColor(isActive),
        "p-id": "1032"
      }
    )
  );
};
var Left = ({ isActive }) => {
  return /* @__PURE__ */ React7__default.default.createElement(
    "svg",
    {
      viewBox: "0 0 1024 1024",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      "p-id": "1169",
      width: size,
      height: size
    },
    /* @__PURE__ */ React7__default.default.createElement(
      "path",
      {
        d: "M783.36 1003.52c30.72-30.72 30.72-76.8 0-107.52L404.48 512l378.88-378.88c30.72-30.72 30.72-76.8 0-107.52-30.72-30.72-76.8-30.72-107.52 0L240.64 455.68c-30.72 30.72-30.72 76.8 0 107.52l435.2 435.2c30.72 30.72 76.8 30.72 107.52 5.12z",
        fill: getArrowColor(isActive),
        "p-id": "1170"
      }
    )
  );
};
var Right = ({ isActive }) => {
  return /* @__PURE__ */ React7__default.default.createElement(
    "svg",
    {
      viewBox: "0 0 1024 1024",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      "p-id": "1307",
      width: size,
      height: size
    },
    /* @__PURE__ */ React7__default.default.createElement(
      "path",
      {
        d: "M240.64 20.48c-30.72 30.72-30.72 81.92 0 112.64l378.88 378.88-378.88 378.88c-30.72 30.72-30.72 76.8 0 107.52s76.8 30.72 107.52 0l435.2-435.2c30.72-30.72 30.72-76.8 0-107.52L348.16 20.48c-30.72-25.6-76.8-25.6-107.52 0z",
        fill: getArrowColor(isActive),
        "p-id": "1308"
      }
    )
  );
};

// src/components/arrowsWrapper/index.tsx
var builtInArrowsRenderMap = {
  ["Left" /* Left */]: Left,
  ["Right" /* Right */]: Right,
  ["Top" /* Top */]: Up,
  ["Bottom" /* Bottom */]: Down
};
var ArrowsWrapper = (props) => {
  const { renderArrows } = props;
  const renderMap = React7__default.default.useMemo(() => {
    return Object.assign(builtInArrowsRenderMap, renderArrows || {});
  }, [renderArrows]);
  const arrowsClassNameMap = React7__default.default.useMemo(() => {
    return {
      ["Left" /* Left */]: "arrow-left",
      ["Right" /* Right */]: "arrow-right",
      ["Top" /* Top */]: "arrow-up",
      ["Bottom" /* Bottom */]: "arrow-down"
    };
  }, []);
  const arrows = React7__default.default.useMemo(() => {
    return ["Top" /* Top */, "Right" /* Right */, "Bottom" /* Bottom */, "Left" /* Left */].map(
      (direction) => {
        const Arrow = renderMap[direction];
        return Arrow ? /* @__PURE__ */ React7__default.default.createElement("div", { className: arrowsClassNameMap[direction], key: direction }, /* @__PURE__ */ React7__default.default.createElement(Arrow, { isActive: props.direction === direction })) : null;
      }
    );
  }, [arrowsClassNameMap, props.direction, renderMap]);
  return /* @__PURE__ */ React7__default.default.createElement("div", { className: "arrows-wrapper" }, arrows);
};
var Controller = React7__default.default.memo(
  ({ className = "", radius }) => {
    const controllerStyle = getStyleByRadius(radius);
    return /* @__PURE__ */ React7__default.default.createElement("div", { className, style: controllerStyle });
  }
);
var ControllerWrapper = React7__default.default.memo(
  React7.forwardRef(({ children, location, transition, style = {}, ...wrapperProps }, ref) => {
    const wrapperStyle = React7__default.default.useMemo(() => {
      return {
        ...style,
        transform: `translate(${location.left}px, ${location.top}px)`,
        ...transition && {
          transition: `transform ${transition / 1e3}s`
        }
      };
    }, [style, location, transition]);
    return /* @__PURE__ */ React7__default.default.createElement("div", { className: "controller-wrapper", style: wrapperStyle, ...wrapperProps, ref }, children);
  })
);

// src/components/joystick/index.tsx
var Joystick = React7__default.default.memo((props) => {
  const {
    className = "",
    controllerClassName = "",
    baseRadius = 75,
    controllerRadius = 35,
    insideMode,
    throttle = 0,
    renderController,
    directionCount = 0 /* Five */
  } = props;
  const [angle, setAngle] = React7__default.default.useState();
  const [distance, setDistance] = React7__default.default.useState(0);
  const controllerWrapper = React7__default.default.useRef(null);
  const direction = React7__default.default.useMemo(() => {
    return angleToDirection(directionCount, angle);
  }, [angle, directionCount]);
  const touchPoint = React7__default.default.useRef({
    left: 0,
    top: 0
  });
  const isControlling = React7__default.default.useRef(false);
  const [controllerTransition, setControllerTransition] = React7__default.default.useState(0);
  const outerRadius = React7__default.default.useMemo(() => {
    return insideMode ? baseRadius - controllerRadius : baseRadius;
  }, [insideMode, baseRadius, controllerRadius]);
  const initialControllerLocation = React7__default.default.useMemo(() => {
    const diff = baseRadius - controllerRadius;
    return {
      top: diff,
      left: diff
    };
  }, [baseRadius, controllerRadius]);
  const [controllerLocation, setControllerLocation] = React7__default.default.useState(initialControllerLocation);
  const { ghost, isActive } = React7__default.default.useContext(GhostContext);
  const { getGhostArea } = React7__default.default.useContext(GhostAreaInstanceContext);
  const baseCls = classnames__default.default("react-joystick", className, {
    ghost,
    "ghost-active": isActive
  });
  const controllerCls = classnames__default.default("react-joystick-controller", controllerClassName);
  const baseStyle = getStyleByRadius(baseRadius);
  const updateControllerLocation = React7__default.default.useCallback(
    (clientX, clientY) => {
      const diffX = clientX - touchPoint.current.left;
      const diffY = clientY - touchPoint.current.top;
      const distanceToCenter = Math.sqrt(diffX * diffX + diffY * diffY);
      setDistance(Math.min(distanceToCenter, outerRadius));
      if (distanceToCenter <= outerRadius) {
        setControllerLocation({
          left: diffX + (baseRadius - controllerRadius),
          top: diffY + (baseRadius - controllerRadius)
        });
      } else {
        const ratio = outerRadius / distanceToCenter;
        const diff = insideMode ? outerRadius : outerRadius - controllerRadius;
        setControllerLocation({
          left: diffX * ratio + diff,
          top: diffY * ratio + diff
        });
      }
      setAngle(getAngle(diffX, diffY));
    },
    [outerRadius, baseRadius, controllerRadius, insideMode]
  );
  React7__default.default.useEffect(() => {
    const onMouseDown = (e) => {
      const isClickGhostArea = e.target === getGhostArea();
      const isClickController = e.target?.parentNode === controllerWrapper.current;
      if (isClickGhostArea || isClickController) {
        isControlling.current = true;
        setControllerTransition(0);
        touchPoint.current = {
          left: e.clientX,
          top: e.clientY
        };
        updateControllerLocation(e.clientX, e.clientY);
      }
    };
    const onMouseMove = (e) => {
      if (!isControlling.current)
        return;
      updateControllerLocation(e.clientX, e.clientY);
    };
    const onMouseUp = () => {
      if (!isControlling.current)
        return;
      isControlling.current = false;
      setAngle(void 0);
      setDistance(0);
      setControllerLocation(initialControllerLocation);
      setControllerTransition(200);
    };
    const onTouchStart = (e) => {
      onMouseDown(e.touches[0]);
    };
    const onTouchMove = ({ touches }) => {
      onMouseMove(touches[0]);
    };
    const onTouchEnd = () => {
      onMouseUp();
    };
    if (reactDeviceDetect.isMobile) {
      document.addEventListener("touchstart", onTouchStart);
      document.addEventListener("touchmove", onTouchMove);
      document.addEventListener("touchend", onTouchEnd);
    } else {
      document.addEventListener("mousedown", onMouseDown);
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    }
    return () => {
      if (reactDeviceDetect.isMobile) {
        document.removeEventListener("touchstart", onTouchStart);
        document.removeEventListener("touchmove", onTouchMove);
        document.removeEventListener("touchend", onTouchEnd);
      } else {
        document.removeEventListener("mousedown", onMouseDown);
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      }
    };
  }, [updateControllerLocation, initialControllerLocation, getGhostArea]);
  const onChange = useThrottle(props.onChange, throttle);
  const onAngleChange = useThrottle(props.onAngleChange, throttle);
  const onDirectionChange = useThrottle(props.onDirectionChange, throttle);
  const onDistanceChange = useThrottle(props.onDistanceChange, throttle);
  React7__default.default.useEffect(() => {
    onChange?.({
      angle,
      direction,
      distance
    });
  }, [direction, angle, distance, onChange]);
  React7__default.default.useEffect(() => {
    onAngleChange?.(angle);
  }, [angle, onAngleChange]);
  React7__default.default.useEffect(() => {
    onDirectionChange?.(direction);
  }, [direction, onDirectionChange]);
  React7__default.default.useEffect(() => {
    onDistanceChange?.(distance);
  }, [distance, onDistanceChange]);
  const controller = React7__default.default.useMemo(() => {
    if (renderController) {
      return renderController({
        radius: controllerRadius,
        className: controllerCls
      });
    }
    return /* @__PURE__ */ React7__default.default.createElement(Controller, { radius: controllerRadius, className: controllerCls });
  }, [controllerCls, controllerRadius, renderController]);
  return /* @__PURE__ */ React7__default.default.createElement("div", { className: baseCls, style: baseStyle }, /* @__PURE__ */ React7__default.default.createElement(ArrowsWrapper, { renderArrows: props.renderArrows, direction }), /* @__PURE__ */ React7__default.default.createElement(
    ControllerWrapper,
    {
      location: controllerLocation,
      transition: controllerTransition,
      ref: controllerWrapper
    },
    controller
  ));
});
var GhostArea = ({
  children,
  className,
  width,
  height
}) => {
  const area = React7__default.default.useRef(null);
  const [activeLocation, setActiveLocation] = React7__default.default.useState(null);
  const [isActive, setIsActive] = React7__default.default.useState(false);
  const onDragStart = React7__default.default.useCallback((clientX, clientY) => {
    if (!area.current)
      return;
    const { left, top, width: w, height: h } = area.current.getBoundingClientRect();
    const nextLeft = clientX - left;
    const nextTop = clientY - top;
    const isValid = nextTop >= 0 && nextTop <= h && w >= 0 && nextLeft <= w;
    if (!isValid)
      return;
    setActiveLocation({
      left: nextLeft,
      top: nextTop
    });
    setIsActive(true);
  }, []);
  const onMouseDown = React7__default.default.useCallback(
    (e) => {
      if (reactDeviceDetect.isMobile)
        return;
      onDragStart(e.clientX, e.clientY);
    },
    [onDragStart]
  );
  const onTouchStart = React7__default.default.useCallback(
    ({ touches }) => {
      if (!reactDeviceDetect.isMobile)
        return;
      const touch = touches[0];
      onDragStart(touch.clientX, touch.clientY);
    },
    [onDragStart]
  );
  const ghostProviderValue = React7__default.default.useMemo(() => {
    return {
      isActive,
      ghost: true
    };
  }, [isActive]);
  const ghostAreaInstanceValue = React7__default.default.useMemo(() => {
    return {
      getGhostArea: () => area.current
    };
  }, []);
  const onMouseUp = React7__default.default.useCallback(() => {
    setIsActive(false);
  }, []);
  React7__default.default.useEffect(() => {
    const eventName = reactDeviceDetect.isMobile ? "touchend" : "mouseup";
    document.addEventListener(eventName, onMouseUp);
    return () => {
      document.removeEventListener(eventName, onMouseUp);
    };
  }, [onMouseUp]);
  const cls = React7__default.default.useMemo(() => {
    return classnames__default.default("react-joystick-ghost-area", className);
  }, [className]);
  const style = React7__default.default.useMemo(() => {
    return { height, width };
  }, [height, width]);
  return /* @__PURE__ */ React7__default.default.createElement(
    "div",
    {
      ref: area,
      className: cls,
      onMouseDown,
      onTouchStart,
      style
    },
    /* @__PURE__ */ React7__default.default.createElement(
      "div",
      {
        className: "react-joystick-wrapper",
        style: { left: activeLocation?.left, top: activeLocation?.top }
      },
      /* @__PURE__ */ React7__default.default.createElement(GhostAreaInstanceContext.Provider, { value: ghostAreaInstanceValue }, /* @__PURE__ */ React7__default.default.createElement(GhostContext.Provider, { value: ghostProviderValue }, children))
    )
  );
};

// src/index.ts
var src_default = Joystick;

exports.Direction = Direction;
exports.DirectionCount = DirectionCount;
exports.GhostArea = GhostArea;
exports.default = src_default;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map